import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import { Autoplay, FreeMode } from 'swiper/modules';

Swiper.use([ FreeMode, Autoplay ]);

export function sliderUtils() {
  const innerContainer = $('.wp-block-image-gallery.is-style-slideshow');
  if (innerContainer.length) {
    window.swiper = new Swiper(innerContainer[0], {
      wrapperClass: 'wp-block-image-gallery__inner-container ',
      slideClass: 'wp-block-image',
      // navigation: false,
      // pagination: false,
      // grabCursor: false,
      simulateTouch: false,
      allowTouchMove: false,
      // allowSlideNext: false,
      // allowSlidePrev: false,
      followFinger: false,
      // longSwipes: false,
      // shortSwipes: false,
      speed: 14000,
      loop: true,
      // initialSlide: 2,
      slidesPerView: 'auto',
      autoplay: {
        delay: 0.5,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        stopOnLastSlide: false,
      },
    });
  }
}
